import request from "@/utils/request";

export interface LoginRequest {
	/**
	 * 登录类型：mobile-手机登录，email-邮箱登录 ，wx-扫码登录, account-账号登录
	 */
	action: string;
	/**
	 * 短信验证码，当action=mobile,当前值不能为空
	 */
	code?: string;
	/**
	 * 邮箱，当action=email,当前值不能为空
	 */
	email?: string;
	/**
	 * 手机号，当action=mobile,当前值不能为空
	 */
	mobile?: string;
	/**
	 * 微信登录jsCode,当action=wx,当前值不能为空
	 */
	wx_code?: string;
	/**
	 * 账号，当action=account,当前值不能为空
	 */
	username?: string;
	/**
	 * 密码，当action=account,当前值不能为空
	 */
	password?: string;
}

export interface LoginResponseData {
	/**
	 * 角色类型：1-平台超级管理类型 2-平台普通管理员 3-SaaS系统超级管理员 4-SaaS系统管理员（普通管理员）
	 */
	admin_type: number;
	/**
	 * 邮箱
	 */
	email: string;
	/**
	 * 当前账号所以规则列表，用于控制按钮的展示
	 */
	form_rule_list: string[];
	/**
	 * 菜单集合
	 */
	menu_navigate: MenuNavigate[];
	/**
	 * 手机号
	 */
	mobile: string;
	/**
	 * 头像
	 */
	photo: string;
	/**
	 * 真实姓名
	 */
	real_name: string;
	/**
	 * 登录sid
	 */
	sid: string;
	/**
	 * 登录token
	 */
	token: string;
	/**
	 * 管理账号用户id
	 */
	user_id: number;
	/**
	 * 用户名称
	 */
	username: string;
	/**
	 * 默认选中组织
	 */
	company: {
		/**
		 * 企业id
		 */
		company_id: number;
		/**
		 * 企业名称
		 */
		name: string;
		/**
		 * 企业logo
		 */
		logo: string;
		/**
		 * 行业分类id
		 */
		industry_id: number;
		/**
		 * 组织分类id
		 */
		institution_id: number;
	};
}

export interface MenuNavigate {
	/**
	 * 子菜单
	 */
	children?: Child[];
	/**
	 * 菜单icon
	 */
	icon?: string;
	/**
	 * 菜单id
	 */
	id?: number;
	/**
	 * 菜单父类id
	 */
	pid?: number;
	/**
	 * 菜单名称
	 */
	rule_name?: string;
}

/**
 * 子菜单集合
 */
export interface Child {
	/**
	 * 子菜单icon
	 */
	icon: string;
	/**
	 * 子菜单id
	 */
	id: number;
	/**
	 * 子菜单父类id
	 */
	pid: number;
	/**
	 * 子菜单名称
	 */
	rule_name: string;
}

export const login = (data: LoginRequest) => request.post<LoginResponseData>("/admin/login", data);

export interface ToggleBusinessRequest {
	/**
	 * 企业id
	 */
	choose_company_id: number;
}

/**
 * 切换企业
 */
export const toggleBusiness = (data: ToggleBusinessRequest) =>
	request.post<LoginResponseData>("/company/toggle", data);

export const loginOut = () => request.post("/admin/loginOut");
